import { render, staticRenderFns } from "./djgqx.vue?vue&type=template&id=81ca876c&scoped=true"
import script from "./djgqx.vue?vue&type=script&lang=js"
export * from "./djgqx.vue?vue&type=script&lang=js"
import style0 from "./djgqx.vue?vue&type=style&index=0&id=81ca876c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ca876c",
  null
  
)

export default component.exports